








































import { Component, Vue } from "vue-property-decorator";
import Multiselect from "vue-multiselect";
import DFilterForm from "@/modules/development-program/filterForm.vue";
import DListOfPrograms from "@/modules/development-program/listOfPrograms.vue";
import AddProgramButton from "@/modules/development-program/AddProgramButton.vue";
import store from "@/services/store";

const axios = require("axios");

@Component({
  components: {
    "add-program-button": AddProgramButton,
    "d-filter-form": DFilterForm,
    "d-list-of-programs": DListOfPrograms,
    multiselect: Multiselect,
  },
})
export default class DInitialForm extends Vue {
  private selectedProgramId: number | null = null;
  private regionsList: any[] = [];
  private selectedRegion: any = null;
  private selectedYear: number = new Date().getFullYear();
  private existingProgramIds: number[] = [];
  private hasEditAccess: boolean = false;

  private async mounted() {
    await this.determineRegionAccess();
    await this.checkUserAccess();
  }

  private async checkUserAccess() {
    try {
      const userId = this.usrId;
      if (!userId) return false;

      const response = await fetch(`/api/um/module/links/${userId}`);
      const moduleLinks = await response.json();

      const programModule = moduleLinks.find(
        (link: any) => link.modules === "003.005"
      );

      if (programModule) {
        this.hasEditAccess = programModule.accessLevel !== 1;
      } else {
        this.hasEditAccess = false;
      }

      return this.hasEditAccess;
    } catch (err) {
      console.error("Error checking user access:", err);
      this.hasEditAccess = false;
      return false;
    }
  }

  private reloadList() {
    const listComponent = this.$refs.listOfPrograms as any;
    listComponent.fetchPrograms();
  }

  private reloadFilter() {
    const filterComponent = this.$refs.filterForm as any;
    if (filterComponent?.reloadAvailablePrograms) {
      filterComponent.reloadAvailablePrograms();
    }
  }

  private get usrId() {
    if (store.state.user.sub === undefined) {
      return null;
    }
    return store.state.user.sub;
  }

  private async determineRegionAccess() {
    const userId = this.usrId;
    if (!userId) return;

    try {
      const authorizedRegions = await fetch(
        `/api/um/user-authorized-kato-regions/${userId}`
      ).then((r) => {
        if (!r.ok) throw new Error(`Authorized regions API error: ${r.status}`);
        return r.json();
      });

      this.regionsList = authorizedRegions.map((r: any) => ({
        code: r.code,
        name: r.name,
      }));
    } catch (err) {
      console.error("Region access error:", err);
      this.makeToast("danger", "Ошибка получения регионов", err.toString());

      try {
        const allKato = await fetch("/api/stat-dict/kato").then((r) =>
          r.json()
        );
        this.regionsList = allKato
          .filter((r: any) => r.code.endsWith("00000"))
          .map((r: any) => ({ code: r.code, name: r.name_ru }));
      } catch (fallbackErr) {
        this.makeToast(
          "danger",
          "Критическая ошибка",
          "Не удалось получить список регионов"
        );
      }
    }
  }

  private makeToast(variant: string, title: string, body: string) {
    this.$bvToast.toast(body, {
      title,
      variant,
      autoHideDelay: 5000,
    });
  }

  private onFilterEmit(payload: {
    year: number;
    region: any;
    programId?: number;
  }) {
    this.selectedYear = payload.year;
    this.selectedRegion = payload.region;
    this.selectedProgramId = payload.programId ?? null;
  }
}
